import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/teams/story-img.jpg")